export default {
  title: 'Crear clave de API',
  reveal_warning: 'Guarda esta clave ahora; no volverá a mostrarse.',
  form: {
    name: 'Nombre',
    name_placeholder: 'p. ej. Clave de producción',
  },
  buttons: {
    cancel: 'Cancelar',
    create: 'Crear',
    done: 'Listo',
  },
  toasts: {
    error: 'No se pudo crear la clave. Inténtalo de nuevo.',
  },
};
